import type { IReportPeriod } from './IReportPeriod'

/** `GET /services/reports/client_losses` (`SPEC-027` §3.3, §5.3). */
export const CLIENT_LOSSES_REPORT_URL = '/services/reports/client_losses'

/** Ключ колонки «Без причини» в `byReason` (`GetClientLossesReportAction::NO_REASON`). */
export const CLIENT_LOSSES_NO_REASON = 'none'

/** Ресурс картки клієнта: відкриваємо за ключем, без імпорту з `CrmSection`. */
export const CLIENT_CARD_RESOURCE = 'Crm.Client'

export interface IClientLossReason {
    uuid: string
    title: string
    /** Причину видалено з довідника, але в періоді є програші з нею (Q3.4). */
    isRemoved: boolean
}

export interface IClientLossesRow {
    client: { uuid: string; title: string }
    applications: number
    /** uuid причини або `none` → кількість; Σ = `applications` (ЗВ-05). */
    byReason: Record<string, number>
}

export interface IClientLossesReport {
    period: IReportPeriod
    reasons: IClientLossReason[]
    rows: IClientLossesRow[]
    total: { applications: number; byReason: Record<string, number> }
}

/**
 * Статус «Програш» для бейджа в підказках (вартовий: статус у підказці —
 * бейджем, а не назвою). Назву й колір бейдж бере з довідника статусів заявок.
 * Ключ і код — ті самі, що в заявки (`APPLICATION_STATUS_RESOURCE`,
 * `APPLICATION_STATUS_CODES.loss`), але без імпорту з `ApplicationContainer`.
 */
export const LOST_APPLICATION_STATUS = { resource: 'Setting.ListApplicationStatus', code: 'application-loss' } as const
